import type { ModuleRoute } from '../types';
import { GroupDetailPage } from './GroupDetailPage';
import { GroupsPage } from './GroupsPage';
import { SiteDetailPage } from './SiteDetailPage';
import { SitesPage } from './SitesPage';

/** Pages of this area. Owned by Phase 1 task W1; only that task edits files in this folder. */
export const routes: ModuleRoute[] = [
  { path: '/manage/sites', element: <SitesPage />, permission: 'sites.view' },
  { path: '/manage/sites/:id', element: <SiteDetailPage />, permission: 'sites.view' },
  { path: '/manage/groups', element: <GroupsPage />, permission: 'groups.view' },
  { path: '/manage/groups/:id', element: <GroupDetailPage />, permission: 'groups.view' },
];
